import React from 'react'

export default function RightOutlined(props) {
  return (
    <svg
      width={props.width ? props.width : '24'}
      height={props.height ? props.height : '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0018 19.0019C9.76811 19.0024 9.54167 18.921 9.36176 18.7719C9.2605 18.6879 9.1768 18.5848 9.11545 18.4685C9.0541 18.3521 9.0163 18.2248 9.00422 18.0939C8.99215 17.9629 9.00603 17.8308 9.04507 17.7052C9.08412 17.5796 9.14756 17.4629 9.23176 17.3619L13.7118 12.0019L9.39176 6.63189C9.30869 6.52961 9.24666 6.41191 9.20923 6.28557C9.1718 6.15923 9.15971 6.02674 9.17364 5.89571C9.18758 5.76468 9.22728 5.6377 9.29045 5.52206C9.35363 5.40643 9.43903 5.30442 9.54176 5.22189C9.64523 5.13086 9.76639 5.06219 9.89765 5.0202C10.0289 4.97821 10.1674 4.96381 10.3045 4.97789C10.4416 4.99198 10.5743 5.03425 10.6943 5.10205C10.8143 5.16985 10.919 5.26172 11.0018 5.37189L15.8318 11.3719C15.9788 11.5508 16.0592 11.7753 16.0592 12.0069C16.0592 12.2385 15.9788 12.463 15.8318 12.6419L10.8318 18.6419C10.7314 18.7629 10.604 18.8586 10.4598 18.9211C10.3156 18.9837 10.1587 19.0113 10.0018 19.0019Z'
        fill={props.color ? props.color : '#1D79FB'}
      />
    </svg>
  )
}
